import styles from '../ads.module.css';

export function AdsPlaceholder() {
  return (
    <div className={styles.ads_placeholder}>
      <div className={styles.path_1}></div>
      <div className={styles.path_2}></div>
    </div>
  );
}
